import React from 'react';
import styles from './footer.module.css';
import internalPdf from "../../assets/userguide_internal.pdf"
import customerPdf from "../../assets/userguide_customer.pdf"

export function Footer({isInternal,...props}) {

    const leftElements = [
        { label: "Privacy Policy", 
          url: "https://www.vodafone.com/about-vodafone/where-we-operate/voice-and-roaming-services/privacy-policy?elqTrackId=0c95dbd4972a4a95abd8362975a920c3&elqaid=3714&elqat=2" 
        },
    ];

    const currentYear = new Date().getFullYear()
    const rightElement = `© ${currentYear} Vodafone Group`;

    return (
        <div className={styles.footer}>
            <div className={styles.leftside}>
            <div className={styles.wrapper}>
                {leftElements.map((element, index) => (
                    <a key={index} href={element.url} target="_blank" rel="noopener noreferrer" className={styles.element}>
                        {element.label}
                    </a>
                ))}
            </div>
            {/* <div className={styles.wrapper}>
                <a href={isInternal?internalPdf:customerPdf} target="_blank" rel="noopener noreferrer" className={styles.element}>User Guide</a>
            </div> */}
            </div>
            <div className={styles.rightside}>
                {rightElement}
            </div>
        </div>
    );
}
